import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export interface PageHeaderProps {
  eyebrow?: string;
  title: string;
  description?: ReactNode;
  actions?: ReactNode;
}

/** Seitenkopf nach Nidus-Vorlage: Eyebrow → Titel → Beschreibung, Aktionen rechts. */
export function PageHeader({ eyebrow, title, description, actions }: PageHeaderProps) {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: 2, mb: 3 }}>
      <Box sx={{ minWidth: 0 }}>
        {eyebrow && (
          <Typography variant="overline" sx={{ color: 'primary.main', display: 'block' }}>
            {eyebrow}
          </Typography>
        )}
        <Typography variant="h3" component="h1">
          {title}
        </Typography>
        {description && (
          <Typography variant="body1" component="div" sx={{ color: 'text.secondary', mt: 0.5, maxWidth: 760 }}>
            {description}
          </Typography>
        )}
      </Box>
      {actions && <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap' }}>{actions}</Box>}
    </Box>
  );
}
